import http from '@/axios/http'

// Classificação final (pódio + posição de cada robô) por categoria do evento.
// Leitura pública, como as demais consultas de resultado.
export const finalStandings = (eventId) =>
  http
    .get(`/get_final_standings?event_id=${eventId}`)
    .then(response => response.data)
